import PropTypes from 'prop-types';
import { Component } from 'react';
import { createPortal, render } from 'react-dom';
import domElementPropType from '../../utils/propTypes/domElement';

class PortalLayer extends Component {
  componentWillUnmount() {
    const {
      element,
      renderTree
    } = this.props;
    const closeTransitionTree = renderTree(null);
    if (!closeTransitionTree) return;
    const firstChild = element.firstChild;
    if (!firstChild || !firstChild.children) return;
    const originalTransitionContents = Array.from(firstChild.children).map(childElement => childElement.cloneNode(true));
    const closeTransitionContainer = document.createElement('div');
    element.appendChild(closeTransitionContainer);
    render(closeTransitionTree, closeTransitionContainer, () => {
      originalTransitionContents.forEach(el => {
        if (closeTransitionContainer.firstChild !== null) {
          closeTransitionContainer.firstChild.appendChild(el);
        }
      });
    });
  }

  render() {
    const {
      children,
      element,
      renderTree
    } = this.props;
    const tree = renderTree(children);
    return /*#__PURE__*/createPortal(tree, element);
  }

}

PortalLayer.propTypes = {
  children: PropTypes.node.isRequired,
  element: domElementPropType.isRequired,
  renderTree: PropTypes.func.isRequired
};
export default PortalLayer;